import React from "react"
import { View, Text, StyleSheet } from "react-native"
import { COLORS } from "../../screens/tenants/tenantOnboarding/screens/components/PropertyDetailsCard"

interface Props {
  firstName?: string
  lastName?: string
  email?: string
  postcode?: string
  contact?: string
  isLead?: boolean
}

export default function PersonCard({
  firstName,
  lastName,
  email,
  postcode,
  contact,
  isLead
}: Props) {

  const initials =
    `${firstName?.[0] || ""}${lastName?.[0] || ""}`.toUpperCase()

  return (
    <View style={styles.card}>

      <View style={styles.headerRow}>
        <View style={styles.avatar}>
          <Text style={styles.avatarText}>{initials}</Text>
        </View>

        <View style={{ flex: 1 }}>
          <Text style={styles.name}>
            {firstName} {lastName}
            {isLead && <Text style={styles.lead}>  (Lead)</Text>}
          </Text>
        </View>
      </View>

      {email && (
        <Text style={styles.text}>Email: {email}</Text>
      )}

      {postcode && (
        <Text style={styles.text}>Postcode: {postcode}</Text>
      )}

      {contact && (
        <Text style={styles.text}>Contact: {contact}</Text>
      )}

    </View>
  )
}

const styles = StyleSheet.create({

  card: {
    backgroundColor: "#F9FAFB",
    padding: 10,
    borderRadius: 14,
    marginBottom: 14,
    shadowColor: "#000",
    shadowOpacity: 0.05,
    shadowRadius: 10,
    elevation: 3,
    borderWidth:0.5,
    marginLeft:6
  },

  headerRow: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 10,
  },

  avatar: {
    width: 42,
    height: 42,
    borderRadius: 21,
    backgroundColor: "#E9D8F7",
    justifyContent: "center",
    alignItems: "center",
    marginRight: 12,
  },

  avatarText: {
    color: COLORS.primary,
    fontWeight: "700",
    fontSize: 14,
  },

  name: {
    fontSize: 15,
    fontWeight: "700",
    color: "#111827",
  },

  lead: {
    fontSize: 13,
    color: COLORS.primary,
    fontWeight: "600",
  },

  text: {
    fontSize: 13,
    color: "#6B7280",
    marginBottom: 3,
  },

})
